import { ValueFormatterParams } from "ag-grid-community";
import React, { useRef, useState } from "react";
import Grid from "../../../../components/Grid";
import { ColumnDef, GridHandle } from "../../../../components/Grid/model/Grid";
import Loading from "../../../../core/common/Loading";
import { IFinanceiroFaturamento } from "./types/types";
import Info from "./Info";

const Faturamento: React.FC = () => {
  const [loading] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<IFinanceiroFaturamento | undefined>();
  const [isView, setIsView] = useState(false);
  const gridRef = useRef<GridHandle>(null);

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    }).format(value);
  };

  const formatDate = (value: string) => {
    if (!value) return "-";
    const date = new Date(value);
    if (isNaN(date.getTime())) return value;

    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  };

  const columns: ColumnDef[] = [

    {
      field: "data_hora",
      headerName: "Data do Movimento",
      filter: true,
      flex: 1,
      valueFormatter: (params: ValueFormatterParams) => formatDate(params.value),
    },
    {
      field: "tipo_veiculo",
      headerName: "Tipo Veículo",
      filter: true,
      flex: 1,
    },
    {
      field: "container",
      headerName: "Container",
      filter: true,
      flex: 1,
    },
    {
      field: "placa",
      headerName: "Placa",
      filter: true,
      flex: 1,
    },
    {
      field: "quantia_paga",
      headerName: "Valor",
      filter: true,
      flex: 1,
      type: "numberColumn",
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value !== undefined && params.value !== null) {
          return formatCurrency(Number(params.value));
        }
        return "-";
      },
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
  ];

  return (
    <>
      <Loading loading={loading} />

      {isView && (
        <Info
          data={selectedRow}
          title="Detalhes - Faturamento"
          onClose={() => setIsView(false)}
        />
      )}

      <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
        <div className="flex items-center justify-between w-full mb-3">
          <div>
            <h1 className="text-2xl text-[#000000] font-bold">Faturamento</h1>
          </div>
        </div>

        <div className="flex w-full h-full">
          <Grid
            ref={gridRef}
            columns={columns}
            filters={[]}
            pagination
            path="/listar/financeiroFaturamento"
            status={[{ id: 14, label: "Check Out - Pago", color: "#b0b9eb", icon: "#788bfa" }]}
            isShowStatus
            defaultSortField="status"
            perPage={20}
            onView={(data: IFinanceiroFaturamento) => {
              setSelectedRow(data);
              setIsView(true);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Faturamento;
